/**
 * Translates the plans data structure using the translation function
 * @param {Object} plansData - The plans data object
 * @param {Function} t - The translation function from useTranslation hook
 * @returns {Object} Translated plans data
 */
export const translatePlans = (plansData, t) => {
  if (!plansData || !t) return plansData;

  const translatedPlans = {
    high_level_goals: {}
  };

  // Iterate through categories
  Object.entries(plansData.high_level_goals || {}).forEach(([category, subcategories]) => {
    if (category === 'quantifiable_success_targets') {
      translatedPlans.high_level_goals[category] = subcategories;
      return;
    }

    translatedPlans.high_level_goals[category] = {};

    // Iterate through subcategories
    Object.entries(subcategories).forEach(([subcategory, goals]) => {
      if (!Array.isArray(goals)) {
        translatedPlans.high_level_goals[category][subcategory] = goals;
        return;
      }

      // Translate each goal
      translatedPlans.high_level_goals[category][subcategory] = goals.map((goal, goalIndex) => {
        const translatedGoal = { ...goal };

        // Translate goal text
        const goalKey = `plans.goals.${category}.${subcategory}.${goalIndex}.goal`;
        translatedGoal.goal = t(goalKey, goal.goal);

        // Translate timeline
        const timelineKey = `plans.goals.${category}.${subcategory}.${goalIndex}.timeline`;
        translatedGoal.timeline = t(timelineKey, goal.timeline);

        // Translate quantifiable_success_metrics
        // IMPORTANT: Keys are preserved (e.g., "starting_score_range", "target_score")
        // Only the VALUES are translated to maintain backward compatibility
        if (goal.quantifiable_success_metrics) {
          translatedGoal.quantifiable_success_metrics = {};
          Object.entries(goal.quantifiable_success_metrics).forEach(([metricKey, metricValue]) => {
            // Preserve the key - only translate the value
            const metricTranslationKey = `plans.goals.${category}.${subcategory}.${goalIndex}.metrics.${metricKey}`;
            translatedGoal.quantifiable_success_metrics[metricKey] = t(metricTranslationKey, metricValue);
          });
        }

        // Translate quantifiable_success_targets
        // IMPORTANT: Keys are preserved (e.g., "6_month_target", "12_month_target")
        // Only the VALUES are translated to maintain backward compatibility
        if (goal.quantifiable_success_targets) {
          translatedGoal.quantifiable_success_targets = {};
          Object.entries(goal.quantifiable_success_targets).forEach(([targetKey, targetValue]) => {
            // Preserve the key - only translate the value
            const targetTranslationKey = `plans.goals.${category}.${subcategory}.${goalIndex}.targets.${targetKey}`;
            translatedGoal.quantifiable_success_targets[targetKey] = t(targetTranslationKey, targetValue);
          });
        }

        return translatedGoal;
      });
    });
  });

  return translatedPlans;
};

export default translatePlans;

